import { Loader } from "lucide-react";
import React, { useState } from "react";
import { successToast,errorToast } from '../../utils/toasters'
import { handlePostRequest } from "../../hooks/api";

export default function ReviewModal({ fetcher,businessDetail, open, setOpen }) {
  const initialState = {
    quality_rating: 95,
    service_rating: 95,
    price_rating: 95,
    review: ""
  };
  const [inputForm, setInputForm] = useState(initialState);
  const [isProcessing, setIsProcessing] = useState(false);

  const handleInputChange = e => {
    const { name, value } = e.target;
    if (value > 100) {
      errorToast("Rating Value Cannot Exceed 100");
      return;
    }
    if (value < 0 || value == "-") {
      errorToast("Min Rating Value can be 0");
      return;
    }
    setInputForm(prev => {
      return { ...prev, [name]: value };
    });
  };

  const handleFormSubmit = async () => {

    const geohash = localStorage.getItem("geohash") || "9v6m";
    const googleApiKey = process.env.REACT_APP_GOOGLEMAP_API;
    try {
      setIsProcessing(true);
      const payload = {
        rating: {
          ...inputForm
        },
        business: {
          businessname: businessDetail.name,
          businessaddress1: businessDetail.formatted_address,
          businesslocationmap: businessDetail.geometry.location,
          businessimageurl: businessDetail.photos
            ? `https://maps.googleapis.com/maps/api/place/photo?maxwidth=400&photo_reference=${
                businessDetail.photos[0].photo_reference
              }&key=${googleApiKey}`
            : null,
          status: "Unverified via Google",
          is_registered: false,
          google_place_id: businessDetail.place_id,
          geohash: geohash
        },
        business_id: businessDetail.id ?? null
      };
      const submitResponse = await handlePostRequest(
        "/business/addBusinessRating",
        payload,
        undefined
      );
      if (submitResponse?.error) {
        throw new Error(submitResponse.error);
      }
      fetcher((prev)=>!prev)
      successToast("Rating Submitted Successfully");
    } catch (error) {
      console.error("error while  submitting rating :", error);
      errorToast("Error while submitting form");
    } finally {
      setIsProcessing(false);

      setOpen(false);
    }
  };

  return (
    <div className="p-4">
      {open && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-2 sm:p-4 overflow-y-auto">
          {isProcessing && (
            <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex items-center justify-center z-50">
              <Loader className="animate-spin" width={64} height={64} />
            </div>
          )}

          <div className="bg-white rounded-lg w-full max-w-[600px] relative shadow-xl mx-auto my-auto">
            <button
              onClick={() => setOpen(false)}
              className="absolute right-3 top-3 sm:right-4 sm:top-4 text-[#232123] hover:text-[#232123]/80 p-1 touch-manipulation"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18 6L6 18M6 6L18 18"
                  stroke="#232123"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>

            <div className="p-4 sm:p-6 md:p-8 pb-4 sm:pb-6">
              <h2 className="text-xl sm:text-[22px] font-semibold text-[#232123]">
                Write a review
              </h2>

              {/* Horizontal border after header */}
              <div className="border-t border-[#e1e5e4] my-4 sm:my-6" />

              <div className="flex flex-col items-center mb-4">
                <div className="w-[60px] h-[60px] bg-[#f5f3f5] rounded-md overflow-hidden mb-2">
                  <img
                    src="/image/business.png?height=60&width=60"
                    alt="Restaurant"
                    className="w-full h-full object-cover"
                  />
                </div>
                <h3 className="font-medium text-[#232123] text-base">
                  {businessDetail.name}
                </h3>
                <p className="text-sm text-[#777280] mt-0.5 text-center px-2">
                  {businessDetail.vicinity}
                </p>

                <div className="flex items-center gap-1 mt-3 text-[#232123]">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="#d6722d"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
                      stroke="#d6722d"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <span className="font-semibold text-base">
                    {inputForm.quality_rating}:{inputForm.service_rating}:{
                      inputForm.price_rating
                    }
                  </span>
                </div>
              </div>

              {/* Horizontal border after restaurant info */}
              <div className="border-t border-[#e1e5e4] my-4 sm:my-6 w-full" />

              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mb-6">
                {/* Quality Rating */}
                <div>
                  <div className="flex items-center gap-2 mb-2">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="#232123"
                        strokeWidth="2"
                      />
                      <path
                        d="M8 12L10.5 14.5L16 9"
                        stroke="#232123"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <h4 className="font-medium text-[#232123] text-base">
                      Rate the Quality
                    </h4>
                  </div>
                  <div className="border border-[#e1e5e4] rounded-md p-4 flex items-center justify-between">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill={inputForm.quality_rating > 0 ? "#d6722d" : "none"}
                      xmlns="http://www.w3.org/2000/svg"
                      className="cursor-pointer touch-manipulation min-w-[20px]"
                    >
                      <path
                        d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
                        stroke="#d6722d"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <input
                      name="quality_rating"
                      value={inputForm.quality_rating}
                      onChange={e => handleInputChange(e)}
                      className="text-[#232123] focus:outline-none focus:ring-0 text-sm w-[100%] text-decoration-none border-none"
                    />
                  </div>
                </div>

                {/* Service Rating */}
                <div>
                  <div className="flex items-center gap-2 mb-2">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="#232123"
                        strokeWidth="2"
                      />
                      <path
                        d="M7 11L9 13L11 15M13 15L15 13L17 11"
                        stroke="#232123"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <circle
                        cx="12"
                        cy="8"
                        r="2"
                        stroke="#232123"
                        strokeWidth="2"
                      />
                    </svg>
                    <h4 className="font-medium text-[#232123] text-base">
                      Rate the Service
                    </h4>
                  </div>
                  <div className="border border-[#e1e5e4] rounded-md p-4 flex items-center justify-between">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill={inputForm.service_rating > 0 ? "#d6722d" : "none"}
                      xmlns="http://www.w3.org/2000/svg"
                      className="cursor-pointer touch-manipulation min-w-[20px]"
                    >
                      <path
                        d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
                        stroke="#d6722d"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <input
                      name="service_rating"
                      value={inputForm.service_rating}
                      onChange={e => handleInputChange(e)}
                      className="text-[#232123] focus:outline-none focus:ring-0 text-sm w-[100%] text-decoration-none border-none"
                    />
                  </div>
                </div>

                {/* Price Rating */}
                <div className="sm:col-span-2 md:col-span-1">
                  <div className="flex items-center gap-2 mb-2">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="#232123"
                        strokeWidth="2"
                      />
                      <path
                        d="M16.5 12H12m-4.5 0H12m0 0V7.5m0 4.5v4.5"
                        stroke="#232123"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                    </svg>
                    <h4 className="font-medium text-[#232123] text-base">
                      Rate the Price
                    </h4>
                  </div>
                  <div className="border border-[#e1e5e4] rounded-md p-4 flex items-center justify-between">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill={inputForm.price_rating > 0 ? "#d6722d" : "none"}
                      xmlns="http://www.w3.org/2000/svg"
                      className="cursor-pointer touch-manipulation min-w-[20px]"
                    >
                      <path
                        d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
                        stroke="#d6722d"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <input
                      name="price_rating"
                      value={inputForm.price_rating}
                      onChange={e => handleInputChange(e)}
                      className="text-[#232123] focus:outline-none focus:ring-0 text-sm w-[100%] text-decoration-none border-none"
                    />
                  </div>
                </div>
              </div>

              <textarea
                placeholder="Tell us what you loved about (Optional)"
                value={inputForm.review}
                name="review"
                onChange={e => handleInputChange(e)}
                className="w-full border border-[#e1e5e4] rounded-md p-4 min-h-[100px] text-sm text-[#232123] placeholder:text-[#9a999a] resize-none focus:outline-none focus:ring-1 focus:ring-[#7b189f]"
              />
            </div>

            <div className="flex justify-between p-4 border-t border-[#e1e5e4]">
              <button
                className="text-[#232123] bg-transparent hover:bg-transparent font-normal text-base touch-manipulation"
                onClick={() => setOpen(false)}
              >
                Back
              </button>
              <button
                className="bg-[#7b189f] hover:bg-[#7b189f] text-white px-6 sm:px-8 py-2 rounded-md touch-manipulation"
                onClick={() => handleFormSubmit()}
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
